import GraphCardExtra from './GraphCardExtra';

export default GraphCardExtra;
